import { formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { EProductMappingType } from '../../interfaces/channel-product-mapping.interface';

@Component({
  selector: 'lum-channel-product-mapping-last-pushed-cell-renderer',
  templateUrl: './channel-product-mapping-last-pushed-cell-renderer.component.html',
  styleUrls: ['./channel-product-mapping-last-pushed-cell-renderer.component.scss'],
})
export class ChannelProductMappingLastPushedCellRendererComponent
  implements ICellRendererAngularComp
{
  lastPushQuantity :number;
  lastPushDatetime :string = '';
  remarks :string = '';

  agInit(params :ICellRendererParams) :void {
    this.lastPushQuantity = params.data?.productOverride?.lastPushQuantity || 0;
    this.lastPushDatetime = params.data?.productOverride?.lastPushDatetime
      ? formatDate(params.data?.productOverride?.lastPushDatetime, 'short', 'en-US')
      : '';
    this.remarks = params.data?.productOverride?.remarks || '';
  }

  refresh(params :ICellRendererParams) :boolean {
    this.agInit(params);

    return true;
  }
}
